import React from "react";

interface Option {
    value: string;
    text: string;
}

interface Props {
    id?: string;
    labelText?: string;
    required?: boolean;
    isInvalid?: boolean;
    options: Option[];
    className?: string;
    currentValue?: string | number;
}

const SelectInput = (props: Props, ref: any) => {
    const { id, labelText, required, isInvalid, options, currentValue, ...rest } = props;

    return (
        <div className="form-group mb-3">
            {labelText && (
                <label htmlFor={id}>
                    {labelText}
                    {required ? <span className="text-danger">*</span> : ""}
                </label>
            )}

            <select
                id={id}
                className={`form-control mb-0 ${isInvalid && "is-invalid"}`}
                required={required}
                ref={ref}
                {...rest}
            >
                <option value="">Select {labelText}</option>
                {options &&
                    options.length > 0 &&
                    options.map((option, index) => {
                        return (
                            <option key={index} value={option.value}>
                                {option.text}
                            </option>
                        );
                    })}
            </select>

            {isInvalid && <div className="invalid-feedback">Invalid Value</div>}
        </div>
    );
};

export default React.forwardRef(SelectInput);
